import either, { left, right } from "../../../lib/either";
import AuthRemoteDataSource from "../datasource/auth_remote_datasource";

const GetRelativeBySignupTokenUseCase = (signUpToken) =>
  either(async () => {
    try {
      const { data } = await AuthRemoteDataSource.relatives(signUpToken);

      return right(data);
    } catch (err) {
      return left(err);
    }
  });

export default GetRelativeBySignupTokenUseCase;
